import {
  HeartHandshake,
  ShieldCheck,
  Sparkles,
  Gift,
  Heart,
  Users,
  Compass,
} from "lucide-react";

export const HeartLogo = ({ size = 26 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <defs>
      <linearGradient id="amoraHeart" x1="0" y1="0" x2="24" y2="24" gradientUnits="userSpaceOnUse">
        <stop stopColor="#7B2FF7" />
        <stop offset="1" stopColor="#D14BF5" />
      </linearGradient>
    </defs>
    <path
      d="M12 21s-7.5-4.9-10-9.4C.3 8.3 1.9 4.5 5.6 4.5c2 0 3.4 1.1 4.4 2.5C11 5.6 12.4 4.5 14.4 4.5c3.7 0 5.3 3.8 3.6 7.1C19.5 16.1 12 21 12 21z"
      fill="url(#amoraHeart)"
    />
  </svg>
);

const map = {
  "heart-handshake": HeartHandshake,
  "shield-check": ShieldCheck,
  sparkles: Sparkles,
  gift: Gift,
  heart: Heart,
  users: Users,
  compass: Compass,
};

export const FeatureIcon = ({ name, size = 26 }) => {
  const Cmp = map[name] || Sparkles;
  return <Cmp size={size} strokeWidth={1.8} color="var(--accent-to)" />;
};
